import React from "react";
import { useHistory } from "react-router-dom";
import { withStyles } from "@material-ui/core";
import Button from "storybookComponents/Button";
import { getEditEventPath, getAppPath } from "constants/path";

const styles = (theme) => ({
  superContainer: {
    height: 50,
    background: "#26BBED",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    padding: "12px 20px",
  },
  buttonClass: {
    color: "white",
    border: "1px solid white",
    "&:hover": {
      background: "white !important",
      color: "#26BBED !important",
    },
  },
  rightContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  crossButton: {
    cursor: "pointer",
    marginLeft: 20,
  },
});

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 5L5 19" stroke="white" strokeMiterlimit="10" stroke-linecap="square" />
    <path d="M19 19L5 5" stroke="white" strokeMiterlimit="10" stroke-linecap="square" />
  </svg>
);

const NotificationContent = withStyles(styles)(
  ({ classes, message, buttonText, handleClick, cancelCallback, setNotificationsBarVisible }) => {
    React.useEffect(() => {
      setNotificationsBarVisible(true);
      return () => {
        setNotificationsBarVisible(false);
      };
    }, [1]);
    return (
      <div className={classes.superContainer}>
        <div dangerouslySetInnerHTML={{ __html: message }} />
        <div>
          <Button
            variant="secondary"
            size="sm"
            color="hylyBlue"
            className={classes.buttonClass}
            onClick={handleClick}
          >
            {buttonText}
          </Button>
          {cancelCallback ? (
            <span className={classes.crossButton} onClick={cancelCallback}>
              <CloseIcon />
            </span>
          ) : null}
        </div>
      </div>
    );
  }
);

const NotificationBar = ({ list = [], setNotificationsBarVisible, show, handleCloseCallback }) => {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;
  const handleClickSingleRequest = (data) => {
    let event = data.node.hyevent;
    window.location.replace(getEditEventPath(event));
  };
  const handleClickMultiRequest = () => {
    history.push(getAppPath() + "/events/approvals/my-approval");
  };
  if (!list.length || !show) return null;
  // if (pathname.includes("approvals") || pathname.includes(getAppPath() + "/event/")) return null;
  if (list.length === 1) {
    return (
      <NotificationContent
        message={`Agent from <b>${list[0].node.propertyName}</b> has sent you an event request for approval.`}
        buttonText="Review Event"
        handleClick={handleClickSingleRequest.bind(this, list[0])}
        setNotificationsBarVisible={setNotificationsBarVisible}
        cancelCallback={handleCloseCallback.bind(this, "hyEvents")}
      />
    );
  } else {
    return (
      <NotificationContent
        message={`You have received <b>${list.length} event requests</b> for approval from multiple agents.`}
        buttonText="Review All Requests"
        handleClick={handleClickMultiRequest}
        setNotificationsBarVisible={setNotificationsBarVisible}
        cancelCallback={handleCloseCallback.bind(this, "hyEvents")}
      />
    );
  }
};

export default NotificationBar;

export const NotificationBarHyBlast = ({
  list = [],
  handleReviewClick,
  show,
  handleCloseCallback,
  setNotificationsBarVisible,
}) => {
  if (!list.length || !show) return null;
  if (list.length === 1) {
    return (
      <NotificationContent
        message={`Agent from <b>${list[0].node.propertyName}</b> has sent you an e-blast approval request.`}
        buttonText="Review E-blast"
        handleClick={handleReviewClick.bind(this, list[0])}
        cancelCallback={handleCloseCallback}
        setNotificationsBarVisible={setNotificationsBarVisible}
      />
    );
  } else {
    return (
      <NotificationContent
        message={`You have received <b>${list.length} e-blast approval requests</b> from multiple agents.`}
        buttonText="Review All E-blasts"
        handleClick={handleReviewClick.bind(this, null)}
        cancelCallback={handleCloseCallback}
        setNotificationsBarVisible={setNotificationsBarVisible}
      />
    );
  }
};
